import { useState } from "react";
import { checkArtisanBookingStatusService } from "../../global-services/status.service";
import {StatusContext} from "./StatusContext";


const StatusProvider = ({ children }) => {

    const [bookingStatus, setBookingStatus] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);

     const checkArtisanBookingStatus = async(artisanId)=>{
        try{
            const data = await checkArtisanBookingStatusService(artisanId)
            console.log(data,'data')
            setBookingStatus(data.booking_status)
            setPaymentStatus(data.payment_status)
            return data
        }catch(err){
            console.log(err)
        }
    }
    return (


    

        <StatusContext.Provider value={{bookingStatus,paymentStatus,checkArtisanBookingStatus}}>
            {children}
        </StatusContext.Provider>
    );
};

export default StatusProvider;